import { render } from "./ClientesFilters.vue?vue&type=template&id=0b866b5a"
import script from "./ClientesFilters.vue?vue&type=script&lang=js"
export * from "./ClientesFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__